import lightGallery from 'lightgallery';

export class gallery {

	constructor() {

		const galleries = document.querySelectorAll('.gallery');
		galleries.forEach(gallery => {
			lightGallery(gallery, {
				speed: 500,
				selector: '.gallery-icon a'
				// getCaptionFromTitleOrAlt: false,
			});
		});

		const customGalleries = document.querySelectorAll('.custom-gallery');
		customGalleries.forEach(gallery => {
			lightGallery(gallery, {
				speed: 500,
				// selector: '.gallery-icon a'
				// getCaptionFromTitleOrAlt: false,
			});
		});

	}
}